import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { TimesState } from "../../types/types";

export const getTime = createAsyncThunk<string[], string>(
  "time/getTime",
  async (currentDate, { rejectWithValue }) => {
    try {
      const dateObj = new Date(currentDate);
      dateObj.setMinutes(dateObj.getMinutes() + dateObj.getTimezoneOffset());
      dateObj.setDate(dateObj.getDate() + 2);

      const correctedDate = dateObj.toISOString().split("T")[0];

      console.log(
        `Запрашиваемая дата: ${currentDate}, исправленная (на +2 дня): ${correctedDate}`
      );
      const API_URL = process.env.REACT_APP_URL_BACKEND;
      const response = await fetch(
        `${API_URL}/api/v1/orders/?consultation_date=${correctedDate}`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Full API Response:", data);

      if (Array.isArray(data)) {
        const freeSlots = data
          .filter((item) => item.is_booked === false)
          .map((item) => item.consultation_time.slice(0, 5));

        console.log("Available slots:", freeSlots);
        return freeSlots;
      } else {
        console.warn("Unexpected API format");
        return [];
      }
    } catch (error) {
      console.error("Error fetching time slots:", error);
      return rejectWithValue(error.message);
    }
  }
);

const initialState: TimesState = {
  time: [],
  loading: false,
  error: null,
};

const timeSlice = createSlice({
  name: "time",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTime.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTime.fulfilled, (state, action) => {
        console.log("Action payload (time slots):", action.payload);
        state.loading = false;
        state.time = action.payload ?? [];
      })
      .addCase(getTime.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default timeSlice.reducer;
